import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { connectPayNow } from '../query-api'

interface UseConnectPayNowProps {
  onError?: () => void
  onSuccess?: () => void
}

export const useConnectPayNow = ({ onError, onSuccess }: UseConnectPayNowProps = {}) => {
  const queryClient = useQueryClient()

  const { mutateAsync: connectAsync, isLoading: isConnecting } = useMutation(connectPayNow, {
    onSuccess: async () => {
      await queryClient.invalidateQueries([QueryKeys.PayNowStatus])
      onSuccess?.()
    },
    onError: () => {
      onError?.()
    },
  })

  return { connectAsync, isConnecting }
}
